// Centralised date formatting.
// Storage format:   ISO yyyy-mm-dd (what <input type="date"> produces)
// Display format:   mm/dd/yyyy  (per user mandate, applied everywhere users read a date)
//
// Usage:
//   import { fmtMDY, fmtISO } from "@/lib/dateFormat";
//   fmtMDY("2025-06-01")  -> "06/01/2025"
//   fmtMDY("")            -> ""
//   fmtMDY(undefined)     -> ""
//   fmtISO("06/01/2025")  -> "2025-06-01"
//
// All parsers tolerate spaces + single-digit months/days.

export function fmtMDY(input) {
  if (!input) return "";
  const str = String(input).trim();
  if (!str) return "";

  // Already mm/dd/yyyy or m/d/yyyy
  const mdy = str.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/);
  if (mdy) {
    const [, m, d, y] = mdy;
    const yy = y.length === 2 ? `20${y}` : y;
    return `${m.padStart(2, "0")}/${d.padStart(2, "0")}/${yy}`;
  }

  // ISO yyyy-mm-dd (optionally with time)
  const iso = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) {
    const [, y, m, d] = iso;
    return `${m}/${d}/${y}`;
  }

  // Last resort: Date object
  const d = new Date(str);
  if (isNaN(d.getTime())) return str;
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${mm}/${dd}/${d.getFullYear()}`;
}

export function fmtISO(input) {
  if (!input) return "";
  const str = String(input).trim();
  const mdy = str.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/);
  if (mdy) {
    const [, m, d, y] = mdy;
    const yy = y.length === 2 ? `20${y}` : y;
    return `${yy}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
  }
  const iso = str.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (iso) return str;
  return "";
}

export function fmtMDYTime(input) {
  if (!input) return "";
  const d = new Date(input);
  if (isNaN(d.getTime())) return String(input);
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return `${mm}/${dd}/${d.getFullYear()} ${hh}:${mi}`;
}
